import {
  ProfessionalProfileResponse,
  ProjectProfileResponseIntroCtaState,
} from '@platform/client/schemas';
import { Icon } from '@platform/components';

export function isIntroStatusTextVisible(state: ProjectProfileResponseIntroCtaState['state']) {
  switch (state) {
    case 'can_send_intro_received':
    case 'can_send_intro_sent':
    case 'matched':
    case 'one_project_intro_received':
    case 'one_project_intro_sent':
      return true;
    default:
      return false;
  }
}

const IntroStateToDescripton: Partial<
  Record<ProjectProfileResponseIntroCtaState['state'], string>
> = {
  matched: 'Matched',
  can_send_intro_received: 'Introduction received',
  can_send_intro_sent: 'Introduction sent',
  one_project_intro_received: 'Introduction received',
  one_project_intro_sent: 'Introduction sent',
};

export const StatusText = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className='flex items-center gap-2 text-success-500 text-base font-semibold'>
      <Icon type='check-circle' size='24' />
      <span>{children}</span>
    </div>
  );
};

/** Shows common text describing the state of your match (or lack thereof) with another user */
const IntroductionStatusText = ({
  introCtaState,
}: {
  introCtaState: ProfessionalProfileResponse['introCtaState'];
}) => {
  let introDescription: string | null = null;
  let introDate: string | null = null;

  if (isIntroStatusTextVisible(introCtaState.state)) {
    introDescription = IntroStateToDescripton[introCtaState.state] as string;
    // Bad hack; hard to type this correctly as it requires getting introCtaState to be typed to only those variants
    // which have a date prop
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    introDate = (introCtaState as any).date;
  }

  return (
    <>
      {introDescription && introDate && (
        <StatusText>
          {introDescription} {introDate}
        </StatusText>
      )}
    </>
  );
};

export default IntroductionStatusText;
